import {
  Modal as CModal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  useDisclosure,
  ModalProps,
} from '@chakra-ui/react';
import React from 'react';

export interface IModalProps {
  modalProps?: Omit<ModalProps, 'children' | 'isOpen' | 'onClose'>;
  modalTrigger: (onOpen: () => void) => React.ReactNode;
  children: (onClose: () => void) => React.ReactNode;
}

const Modal: React.FC<IModalProps> = ({ modalTrigger, children, modalProps }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div>
      {modalTrigger(onOpen)}
      <CModal size="xl" isCentered {...modalProps} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          {children(onClose)}
        </ModalContent>
      </CModal>
    </div>
  );
};

export default Modal;
